import { Link } from 'react-router-dom'
import {
    EnvelopeIcon,
    PhoneIcon,
    MapPinIcon,
    AcademicCapIcon,
    BookOpenIcon,
    QuestionMarkCircleIcon,
    ChatBubbleLeftRightIcon
} from '@heroicons/react/24/outline'

const Footer = () => {
    const currentYear = new Date().getFullYear()

    const quickLinks = [
        { name: 'Home', href: '/' },
        { name: 'Universities', href: '/universities' },
        { name: 'Courses', href: '/courses' },
        { name: 'Blogs', href: '/blogs' },
        { name: 'Contact', href: '/contact' },
    ]

    const services = [
        { name: 'Online MBA', href: '/courses?category=MBA' },
        { name: 'BCA Programs', href: '/courses?category=Engineering' },
        { name: 'MCA Programs', href: '/courses?category=Engineering' },
        { name: 'Distance Learning', href: '/courses?mode=Distance' },
        { name: 'Career Counseling', href: '/contact' },
        { name: 'Admission Guidance', href: '/contact' },
    ]

    const legal = [
        { name: 'About', href: '/about' },
        { name: 'FAQs', href: '/faqs' },
        { name: 'Privacy Policy', href: '/privacy' },
        { name: 'Terms of Service', href: '/terms' },
        { name: 'Disclaimer', href: '/disclaimer' },
    ]

    const socialLinks = [
        {
            name: 'Facebook',
            href: 'https://www.facebook.com/profile.php?id=61558479383234',
            icon: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z'
        },
        {
            name: 'X',
            href: 'https://x.com/mymargdarshak',
            icon: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z'
        },
        {
            name: 'LinkedIn',
            href: 'https://www.linkedin.com/company/109284591',
            icon: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z'
        },
        {
            name: 'Instagram',
            href: 'https://www.instagram.com/mymargdarshak/',
            icon: 'M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987s11.987-5.367 11.987-11.987C24.014 5.367 18.647.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.49-3.323-1.297C4.198 14.895 3.708 13.744 3.708 12.447s.49-2.448 1.418-3.323c.875-.807 2.026-1.297 3.323-1.297s2.448.49 3.323 1.297c.928.875 1.418 2.026 1.418 3.323s-.49 2.448-1.418 3.244c-.875.807-2.026 1.297-3.323 1.297zm7.83-9.405c-.31 0-.56-.25-.56-.56s.25-.56.56-.56.56.25.56.56-.25.56-.56.56zm-1.68 1.68c-.31 0-.56-.25-.56-.56s.25-.56.56-.56.56.25.56.56-.25.56-.56.56zm-1.68 1.68c-.31 0-.56-.25-.56-.56s.25-.56.56-.56.56.25.56.56-.25.56-.56.56z'
        }
    ]

    return (
        <footer className="bg-gray-800 text-gray-100">
            {/* Main Footer Content */}
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
                    {/* Company Info */}
                    <div className="lg:col-span-2">
                        <Link to="/" className="flex items-center space-x-2 mb-6">
                            <img
                                src="/marglogo.png"
                                alt="Margdarshak Logo"
                                className=" h-12 object-contain border-2 border-white rounded-lg"
                            />
                            {/* <div>
                                <h3 className="text-xl font-bold">
                                    <span className="text-accent-500">Marg</span>
                                    <span className="text-primary-600">darshak</span>
                                </h3>
                                <p className="text-sm text-white">YOUR SUCCESS | OUR MISSION</p>
                            </div> */}
                        </Link>
                        <p className="text-gray-300 mb-6 leading-relaxed text-white">
                            Your trusted education guidance platform. We help students find the best online and distance learning programs from top universities.
                        </p>
                        <div className="space-y-3">
                            <div className="flex items-center space-x-3">
                                <EnvelopeIcon className="w-5 h-5 text-accent-400" />
                                <span className="text-gray-300">info@margdarshak.com</span>
                            </div>
                            <div className="flex items-center space-x-3">
                                <PhoneIcon className="w-5 h-5 text-accent-400" />
                                <span className="text-gray-300">+91-9810530354</span>
                            </div>
                            <div className="flex items-center space-x-3">
                                <MapPinIcon className="w-5 h-5 text-accent-400" />
                                <span className="text-gray-300">Lal Kuah, Ghaziabad, Uttar Pradesh, India</span>
                            </div>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="text-lg font-semibold mb-6 flex items-center text-white">
                            <AcademicCapIcon className="w-5 h-5 mr-2 text-secondary-400" />
                            Quick Links
                        </h4>
                        <ul className="space-y-3">
                            {quickLinks.map((link) => (
                                <li key={link.name}>
                                    <Link
                                        to={link.href}
                                        className="text-gray-300 hover:text-accent-400 transition-colors duration-200"
                                    >
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Services */}
                    {/* <div>
                        <h4 className="text-lg font-semibold mb-6 flex items-center text-white">
                            <BookOpenIcon className="w-5 h-5 mr-2 text-secondary-400" />
                            Services
                        </h4>
                        <ul className="space-y-3">
                            {services.map((service) => (
                                <li key={service.name}>
                                    <Link
                                        to={service.href}
                                        className="text-gray-300 hover:text-accent-400 transition-colors duration-200"
                                    >
                                        {service.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div> */}

                    {/* Support & Legal */}
                    <div>
                        <h4 className="text-lg font-semibold mb-6 flex items-center text-white">
                            <QuestionMarkCircleIcon className="w-5 h-5 mr-2 text-secondary-400" />
                            Support
                        </h4>
                        <ul className="space-y-3 mb-8">
                            {legal.map((item) => (
                                <li key={item.name}>
                                    <Link
                                        to={item.href}
                                        className="text-gray-300 hover:text-accent-400 transition-colors duration-200"
                                    >
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>

                        {/* Social Links */}
                        <div>
                            <h5 className="text-sm font-semibold mb-4 text-gray-400 text-white">Follow Us</h5>
                            <div className="flex space-x-4">
                                {socialLinks.map((social) => (
                                    <a
                                        key={social.name}
                                        href={social.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-accent-600 transition-colors duration-200"
                                        aria-label={social.name}
                                    >
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                            <path d={social.icon} />
                                        </svg>
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* Bottom Bar */}
            <div className="border-t border-gray-700">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex flex-col md:flex-row items-center justify-between">
                        <p className="text-gray-400 text-sm text-white">
                            © {currentYear} Margdarshak. All rights reserved.
                        </p>
                        <div className="flex items-center space-x-6 mt-4 md:mt-0">
                            <span className="text-white text-sm">Made with ❤️ for education</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
